export default __webpack_public_path__ + "static/media/recentlyusedadvantage.886c251a.png";